/**
 * @type {import('vue-router').RouteConfig[]}
 */
const routesPersonal = [{
  path: "/team",
  redirect: "/team/member",
  name: "teamManage",
  component: () => import("@/views/team/index.vue"),
  meta: {
    title: "route.team-management",
    crumbs: "route.team-management",
    isLogin: true,
    // 团队管理加入主侧栏入口，子路由的 sidebar 元数据生成悬浮二级菜单。
    sidebar: {
      label: "团队管理",
      labelKey: "route.team-management",
      icon: "Team Management",
      order: 100,
      activePaths: ["/team"]
    },
    // 此路由受用户权限控制,仅限超管(1)和管理员(2)，校验逻辑由 router/index.js 的全局守卫统一处理
    roles: [1, 2]
  },
  children: [
  /*{
    path: "/team/package/purchase",
    component: () => import("@/views/team/package/purchase.vue"),
    name: "teamPackagePurchase",
    meta: {
      title: "route.team-package",
      crumbs: "route.team-package-crumb",
      isLogin: true,
      isNav: false,
      needBackBtn: true,
      parentName: "teamPackage",
    },
  },*/
  {
    path: "/team/member",
    component: () => import("@/views/team/member/index.vue"),
    name: "teamMember",
    meta: {
      title: "route.member-management",
      crumbs: "route.member-management-crumb",
      isLogin: true,
      isNav: true,
      // 主侧栏团队管理二级菜单入口：成员管理，排在第一项。
      sidebar: {
        label: "成员管理",
        labelKey: "route.member-management",
        icon: "Member Management",
        order: 10,
        activePaths: ["/team/member"]
      }
    }
  }, {
    path: "/team/member/detail/:id",
    component: () => import("@/views/team/member/detail.vue"),
    name: "teamMemberDetail",
    meta: {
      title: "route.member-detail",
      crumbs: "route.member-detail-crumb",
      isLogin: true,
      isNav: false,
      needBackBtn: true,
      parentName: "teamMember"
    }
  }, {
    path: "/team/settings",
    component: () => import("@/views/team/setting/index.vue"),
    name: "teamSettings",
    meta: {
      title: "route.team-settings",
      crumbs: "route.team-settings-crumb",
      isLogin: true,
      isNav: true,
      // 主侧栏团队管理二级菜单入口：团队设置。
      sidebar: {
        label: "团队设置",
        labelKey: "route.team-settings",
        icon: "Team Setting",
        order: 40,
        activePaths: ["/team/settings"]
      }
    }
  }, {
    path: "/team/consumption",
    component: () => import("@/views/team/balance/consumption.vue"),
    name: "teamConsumption",
    meta: {
      title: "route.finance",
      crumbs: "route.finance-crumb",
      isLogin: true,
      isNav: true,
      // 消费记录的详情和充值页不是 /team/consumption 子路径，单独归属到该二级入口。
      sidebar: {
        label: "财务信息",
        labelKey: "route.finance",
        icon: "Consumption Record",
        order: 20,
        activePaths: ["/team/consumption", "/team/expenditurDetail", "/team/recharge"]
      }
    }
  }, {
    path: "/team/expenditurDetail",
    component: () => import("@/views/team/expenditureDetail.vue"),
    name: "expenditureDetail",
    meta: {
      title: "route.expense-detail",
      crumbs: "route.expense-detail-crumb",
      isLogin: true,
      isNav: false,
      needBackBtn: true,
      parentName: "teamConsumption"
    }
  }, {
    path: "/team/recharge",
    component: () => import("@/views/team/balance/recharge.vue"),
    name: "teamRecharge",
    meta: {
      title: "route.recharge",
      crumbs: "route.recharge-crumb",
      isLogin: true,
      isNav: false,
      needBackBtn: true,
      parentName: "teamConsumption"
    }
  }
  // {
  //   path: "/team/billingRules",
  //   component: () => import("@/views/team/balance/billingRules.vue"),
  //   name: "teamBillingRules",
  //   meta: {
  //     title: "计费规则",
  //     crumbs: "JoinMC 团队管理 - 计费规则",
  //     isLogin: true,
  //     isNav: true,
  //   },
  // },
  ]
}];
export default routesPersonal;